import { Text } from "@/components/text/text.component";

import type { SanityPlanCompareColumn } from "./useComparePlanTableSectionState";

export const ComparePlanTableColumnHeader = ({
  column,
  layout = "desktop",
}: ComparePlanTableColumnHeaderProps) => {
  if (!column) return null;

  if (layout === "mobile") {
    return (
      <div
        className="flex h-full flex-col items-center justify-end gap-1 px-4 pt-6 pb-2 text-center"
        role="cell">
        <Text
          variant="subtitle1"
          component="p"
          className="text-greyscale-headline">
          {column.title}
        </Text>
        <Text
          variant="subtitle2"
          component="p"
          className="text-greyscale-headline">
          {column.price}
        </Text>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-center gap-1 px-4 py-6 text-center"
      role="cell">
      {column.subtitle ? (
        <Text variant="body2" component="p" className="text-greyscale-body">
          {column.subtitle}
        </Text>
      ) : null}
      <Text variant="h5" component="p" className="text-greyscale-headline">
        {column.title}
      </Text>
      <Text variant="h6" component="p" className="text-greyscale-headline">
        {column.price}
      </Text>
    </div>
  );
};

type ComparePlanTableColumnHeaderProps = {
  column: SanityPlanCompareColumn | null | undefined;
  layout?: "mobile" | "desktop";
};
